// Actions

import axios from '@/axios.js'

export default {
  GetList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/transaction/list',
        params,
        method: 'GET'
      })
      .then(res => {
        console.log(res.data.payload)
        resolve(res.data.payload)
      })
      .catch(err => reject(err))
    })
  }
}
